<template>

    <div class="row">
        <div class="col-md-6">
            <div class="form-group">
                <label for="date">Tanggal </label>
                <input type="date" v-model="model.date" class="form-control" readonly>
            </div>
        </div>
        <div class="col-md-6">
            <div class="form-group">
                <label for="date">Type </label>
                <input type="text" v-model="model.type" class="form-control" readonly>
            </div>
        </div>

        <div class="col-md-6" v-if="model.type == 'out'">
            <div class="form-group">
                <label for="date">Status </label>
                <input type="text" v-model="model.request_type" class="form-control" readonly>
            </div>
        </div>

        <div class="col-md-6">
            <div class="form-group">
                <label for="date">Link Bukti </label>
                <a :href="linkBukti" target="_blank" class="btn btn-outline-primary w-100 text-truncate" disabled>{{ linkBukti }}</a>
            </div>
        </div>

        <div class="col-md-6">
            <div class="form-group">
                <label for="date">Jumlah </label>
                <input type="text" v-model="model.qty" class="form-control" readonly>
            </div>
        </div>

        <div class="col-md-6" v-if="model.type == 'in'">
            <div class="form-group">
                <label for="date">Material dari </label>
                <input type="text" v-model="model.from" class="form-control" readonly>
            </div>
        </div>

        <div class="col-md-6" v-if="model.type == 'out'">
            <div class="form-group">
                <label for="date">Yang mengambil </label>
                <input type="text" v-model="model.to" class="form-control" readonly>
            </div>
        </div>

    </div>

</template>

<script>
export default {
    name: 'FormRiwayat',
    components: {},
    props: { },
    data() {
        return {
            saving: false,
            linkBukti: '',
            model: {
                date: '',
                type: 'in',
                qty: 0,
                attachments: [],
                request_type: '',
                from: '',
                to: '',
            },
            type: '',
        }
    },
    methods: {
        attachmentsInputed() {
            this.model.attachments = []
            this.model.attachments.push(this.linkBukti)
        },
        resetModel() {
            this.model = { date: '', type: 'in', qty: 0, attachments: [], material_id: this.material_id }
            this.linkBukti = ''
        },
        loadDetail(item) {
            this.model.date = item.date
            this.model.type = item.type
            this.model.qty = item.qty
            this.model.request_type = item.request_type
            this.model.from = item.from
            this.model.to = item.to
            this.model.id = item.id
            this.linkBukti = item.attachments[0]
        },
    
    },
    watch: {
    }
}
</script>